
      if (import.meta.env.PROD) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.defer = true;
        script.src = 'https://app.termly.io/resource-blocker/1d56a2ca-b9b6-4cbf-9157-502c1b9e1400';
        document.head.appendChild(script);
      }
    